/**
 * @description 菜单 leftMenu
 * @author xiehan
 * @date 2018/9/20
 */

import Logic from './logic-base'

const leftMenuBiz = new Logic()

leftMenuBiz.getAlarmCount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.leftMenu.getAlarmCount,
    data: data
  })
}

leftMenuBiz.getMenuAndButton = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.leftMenu.getMenuAndButton,
    data: data
  }, false, true)
}

export default leftMenuBiz
